import React, { useState, useEffect } from "react";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useUser, useOrganization } from "@clerk/clerk-react";
import { Loader2 } from "lucide-react"; // Ensure this is the correct library for Loader2
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
// [tutorial disabled] import { driver } from "driver.js";
// [tutorial disabled] import "driver.js/dist/driver.css";
import { useApiFetch, toastError } from "src/lib/api";

export default function DeviceManager() {
  const [devices, setDevices] = useState([]);
  const [product, setProduct] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [editingDeviceId, setEditingDeviceId] = useState(null);
  const [editedDevices, setEditedDevices] = useState({});
  const { organization } = useOrganization();
  const [loading, setLoading] = useState(true); // Estado de carga
  const [showForm, setShowForm] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [selectedDeviceIp, setSelectedDeviceIp] = useState(null); // Selected device IP
  const [selectedDevice, setSelectedDevice] = useState({
    ip: null,
    name: null,
  }); // Selected device (IP and name)
  const [newDevice, setNewDevice] = useState({
    name: "",
    position: [0, 0], // Ensure this is initialized with numbers
    description: "",
    ip_address: "",
    monitor_id: "",
  });

  const { user } = useUser();
  const [role, setRole] = useState("member");
  // const role = user.organizationMemberships[0].role;
  const navigate = useNavigate(); // Hook para redirección
  const apiFetch = useApiFetch();

  // [tutorial disabled] const disableTutorial = async () => {
    // [tutorial disabled] try {
      // [tutorial disabled] const data = await apiFetch("/auth/disable-tutorial", { method: "POST" });
      // [tutorial disabled] if (!data) return;

      // [tutorial disabled] setRole(data?.role || "member");
    // [tutorial disabled] } catch (error) {
      // [tutorial disabled] console.error("Error disabling tutorial:", error);
      // [tutorial disabled] toastError(error);
    // [tutorial disabled] }
  // [tutorial disabled] };

  // [tutorial disabled] /* Display tour tutorial */
  // [tutorial disabled] useEffect(() => {
    // [tutorial disabled] let intervalId = null;

    // [tutorial disabled] const checkForTutorialReady = () => {
      // [tutorial disabled] let step = localStorage.getItem("driver-tutorial-step");
      // [tutorial disabled] const el = document.querySelector("#devices");

      // [tutorial disabled] if (step === "device-manager" && el) {
        // [tutorial disabled] clearInterval(intervalId); // limpiar el polling
        // [tutorial disabled] startDriver(); // lanzar el tour

        // [tutorial disabled] setTimeout(() => {
          // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);
        // [tutorial disabled] }, 1000);
      // [tutorial disabled] }
    // [tutorial disabled] };

    // [tutorial disabled] const startDriver = () => {
      // [tutorial disabled] const driverObj = driver({
        // [tutorial disabled] scrollIntoViewOptions: {
          // [tutorial disabled] behavior: "auto",
          // [tutorial disabled] block: "start", // ← enfoca al principio del viewport (debajo del navbar)
        // [tutorial disabled] },
        // [tutorial disabled] steps: [
          // [tutorial disabled] {
            // [tutorial disabled] element: "#devices",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Device List",
              // [tutorial disabled] description:
                // [tutorial disabled] "This section retrieves the device list. This list can be modified by adding or removing devices and each device can be edited",
              // [tutorial disabled] prevBtnText: `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] },
              // [tutorial disabled] onPrevClick: () => {
                // [tutorial disabled] navigate("/detection");
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "detections");
              // [tutorial disabled] },
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onHighlighted: () => {
              // [tutorial disabled] const enablePrev = () => {
                // [tutorial disabled] const prevBtn = document.querySelector(
                  // [tutorial disabled] ".driver-popover-prev-btn"
                // [tutorial disabled] );
                // [tutorial disabled] if (prevBtn) {
                  // [tutorial disabled] prevBtn.removeAttribute("disabled");
                  // [tutorial disabled] prevBtn.classList.remove("driver-popover-btn-disabled");
                  // [tutorial disabled] clearInterval(retry);
                // [tutorial disabled] }
              // [tutorial disabled] };

              // [tutorial disabled] const retry = setInterval(enablePrev, 100);
              // [tutorial disabled] setTimeout(() => clearInterval(retry), 1000);
            // [tutorial disabled] },
          // [tutorial disabled] },
          // [tutorial disabled] {
            // [tutorial disabled] element: "#filter-bar",
            // [tutorial disabled] popover: {
              // [tutorial disabled] title: "Bar to filter devices by name or add a device",
              // [tutorial disabled] prevBtnText: `
              // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                // [tutorial disabled] <path d="M15 18l-6-6 6-6" />
              // [tutorial disabled] </svg>
            // [tutorial disabled] `,
              // [tutorial disabled] doneBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] nextBtnText: `
                // [tutorial disabled] <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  // [tutorial disabled] <path d="M9 18l6-6-6-6" />
                // [tutorial disabled] </svg>
              // [tutorial disabled] `,
              // [tutorial disabled] onNextClick: () => {
                // [tutorial disabled] if (product === "audio" || product === "both") {
                  // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "dashboard-v1");
                  // [tutorial disabled] navigate("/dashboard");
                // [tutorial disabled] } else {
                  // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "dashboard-v2");
                  // [tutorial disabled] navigate("/dashboard-v2");
                // [tutorial disabled] }
              // [tutorial disabled] },
              // [tutorial disabled] onCloseClick: () => {
                // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
                // [tutorial disabled] driverObj.destroy();
                // [tutorial disabled] disableTutorial();
              // [tutorial disabled] },
            // [tutorial disabled] },
            // [tutorial disabled] onDeselected: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
            // [tutorial disabled] onDestroyed: () => {
              // [tutorial disabled] localStorage.setItem("driver-tutorial-step", "");
              // [tutorial disabled] disableTutorial();
            // [tutorial disabled] },
          // [tutorial disabled] },
        // [tutorial disabled] ],
      // [tutorial disabled] });

      // [tutorial disabled] driverObj.drive();
    // [tutorial disabled] };

    // [tutorial disabled] intervalId = setInterval(checkForTutorialReady, 300);

    // [tutorial disabled] return () => {
      // [tutorial disabled] if (intervalId) clearInterval(intervalId);
    // [tutorial disabled] };
  // [tutorial disabled] }, [product]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDevice({ ...newDevice, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const  deviceData = {
      organizationId: orgId,
      name: newDevice?.name,
      latitude: newDevice?.position?.[0],
      longitude: newDevice.position?.[1],
      ip_address: newDevice?.ip_address,
      monitor_id: newDevice?.monitor_id,
      iccid: newDevice?.iccid,
      throttle: newDevice?.throttle,
    };

    try {
      const data = await apiFetch("/api/devices", {
        method: "POST",
        body: deviceData,
      });
      if (!data) return;

      setDevices((prev) => [...(prev ?? []), data]);
      setFilteredDevicesAvailable(true);

      toast.success("Device added successfully!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Refrescar lista
      await loadDevices();
    } catch (error) {
      console.error("Error saving device:", error);
      toastError(error, "Error adding device");
    }
  };

  // Function to open the modal with selected device's IP
  const openModal = (ip, name) => {
    setSelectedDevice({ ip, name });
    setIsModalOpen(true); // Open the modal
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDeviceIp(null);
  };

  const filteredDevices = Array.isArray(devices)
    ? devices
    : []; /* .filter((device) =>
  device.name.toLowerCase().includes(filterValue.toLowerCase())
) */

  /* const orgId = organization?.id; */
  const [orgId, setOrganizationId] = useState(null);
  const [filteredDevicesAvailable, setFilteredDevicesAvailable] =
    useState(false);

  async function loadDevices() {
    try {
      const data = await apiFetch("/api/devicemanager-list");
      if (!data) return;
      setDevices(data?.result ?? []);
      setFilteredDevicesAvailable(true);
      setProduct(data?.product?.product ?? "");
      /* console.log("OrgId: ", data.organizationId); */
      setOrganizationId(data?.organizationId ?? null);
    } catch (error) {
      console.error("Error fetching devices:", error);
      toastError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    /* console.log("OrgId on DeviceManager: ", orgId); */
    /* if (orgId) { */
    loadDevices();
    /* } */
  }, [orgId]);

  function handleEdit(deviceId) {
    setEditedDevices((prev) => ({
      ...prev,
      [deviceId]: (devices ?? []).find((device) => device?.id === deviceId),
    }));
  }
  const handleDelete = async (deviceId) => {
    const confirmed = window.confirm(
      `Are you sure you want to delete the device: ${deviceId}?`
    );
    if (!confirmed) return;

    try {
      const data = await apiFetch("/api/devicemanager-delete", {
        method: "POST",
        body: { deviceId },
      });
      if (!data) return;

      console.log(`[INFO] Device ${deviceId} deleted successfully`);
      // Actualizar el estado para eliminar el dispositivo de la lista
      setDevices((prevDevices) =>
        (prevDevices ?? []).filter((device) => device?.id !== deviceId)
      );
      setFilteredDevicesAvailable(true);
    } catch (error) {
      console.error("Error deleting device:", error);
      toastError(error, "Failed to delete the device. Please try again.");
    }
  };

  function handleCancel(deviceId) {
    setEditedDevices((prev) => {
      const updated = { ...prev };
      delete updated[deviceId];
      return updated;
    });
  }

  function handleChange(deviceId, field, value) {
    setEditedDevices((prev) => ({
      ...prev,
      [deviceId]: {
        ...prev[deviceId],
        [field]: value,
      },
    }));
  }

  const handleUpdate = async (device) => {
    const updatedDevice = editedDevices[device.id];
    try {
      const data = await apiFetch("/api/devicemanager-update", {
        method: "POST",
        body: updatedDevice,
      });
      if (!data) return;

      /* setDevices((prevDevices) =>
        prevDevices.map((d) =>
          d.id === updatedDevice.id ? updatedDevice : d
        )
      ); */
      setEditingDeviceId(null);
      // Remove the edited device from editedDevices
      setEditedDevices((prev) => {
        const newState = { ...prev };
        delete newState[device.id];
        return newState;
      });
      loadDevices();
      alert("Device updated successfully.");
    } catch (error) {
      console.error("[WARN] Error updating device:", error);
      toastError(error, "Failed to update the device. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <Loader2 className="mr-2 mt-28 h-6 w-6 animate-spin" />
        <span className="mt-28">Loading ...</span>
      </div>
    );
  }

  const throttleOptions = [
    "NO_LIMIT",
    "SPEED_100_KBPS",
    "SPEED_200_KBPS",
    "SPEED_500_KBPS",
    "SPEED_1000_KBPS",
    "SPEED_2500_KBPS",
    "SPEED_5000_KBPS",
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div
          className="flex mb-2 flex-col md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0"
          id="filter-bar"
        >
          <Input
            type="text"
            placeholder="Filter by device name"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="max-w-md"
          />
          <Button
            variant="outline"
            onClick={() => setFilterValue("")}
            className="text-gray-500"
          >
            Clear
          </Button>
          {role === "admin" ? (
            <Button
              variant="outline"
              onClick={() => setShowForm(true)}
              className=" text-gray-500"
            >
              Add device
            </Button>
          ) : (
            <p></p>
          )}
          {showForm && (
            <div className="device-form-container top-48 ml-52 sm:top-20 md:top-24 lg:top-24 xl:top-24">
              <form onSubmit={handleSubmit} className="device-form">
                <label>
                  Device Name:
                  <input
                    type="text"
                    name="name"
                    value={newDevice.name}
                    onChange={handleInputChange}
                    required
                  />
                </label>

                <label>
                  IP Address:
                  <input
                    type="text"
                    placeholder="ex. 192.168.1.1" // Placeholder for IP address suggeriments
                    name="ip_address"
                    value={newDevice.ip}
                    onChange={handleInputChange}
                    required
                  />
                </label>

                <button type="submit">Confirm</button>
                <button type="button" onClick={() => setShowForm(false)}>
                  Cancel
                </button>
              </form>
            </div>
          )}
          <ToastContainer />
        </div>

        {filteredDevices.length === 0 ? (
          <Card className="" id="devices">
            <CardContent className="flex h-15 mt-4 align-middle">
              <p className="text-center text-muted-foreground">
                No devices found
              </p>
            </CardContent>
          </Card>
        ) : (
          <div className="grid gap-4" id="devices">
            {filteredDevicesAvailable &&
              filteredDevices.map((device) => (
                <Card key={device.id} className="w-full">
                  <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {filteredDevicesAvailable &&
                        [
                          "name",
                          "monitor_id",
                          "ip_address",
                          "longitude",
                          "latitude",
                          "iccid",
                          "throttle",
                          ...(orgId === "org_00000000000003" ? ["apoyo_id"] : [])
                        ].map((field) => (
                          <div key={field}>
                            <label className="block text-sm font-medium text-gray-500 mb-1">
                              {field.charAt(0).toUpperCase() +
                                field.slice(1).replace("_", " ")}
                            </label>
                            {editedDevices[device.id] ? (
                              field === "throttle" ? (
                                <select
                                  value={
                                    editedDevices[device.id]?.[field] || ""
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      device.id,
                                      field,
                                      e.target.value
                                    )
                                  }
                                  className="border rounded px-2 py-1"
                                >
                                  
                                  <option  value="" disabled hidden>Select throttle</option>
                                  {throttleOptions.map((opt) => (
                                    <option key={opt} value={opt}>
                                      {opt}
                                    </option>
                                  ))}
                                </select>
                              ) : (
                                <Input
                                  type={
                                    field === "latitude" ||
                                    field === "longitude"
                                      ? "number"
                                      : "text"
                                  }
                                  value={
                                    editedDevices[device.id]?.[field] || ""
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      device.id,
                                      field,
                                      e.target.value
                                    )
                                  }
                                />
                              )
                            ) : (
                              <p className="text-gray-900">{device?.[field] || "Not defined"}</p>
                            )}
                          </div>
                        ))}
                    </div>

                    {/* Actions in the bottom-right corner of the card */}
                    <div className="mt-6 flex flex-wrap justify-end gap-2">
                        {editedDevices[device.id] ? (
                          <div className="flex gap-2">
                            <Button onClick={() => handleUpdate(device)}>
                              Save
                            </Button>
                            <Button
                              variant="outline"
                              onClick={() => handleCancel(device.id)}
                            >
                              Cancel
                            </Button>
                          </div>
                        ) : (
                          <>
                            <div className="flex gap-2">
                              <Button onClick={() => handleEdit(device.id)}>
                                Edit
                              </Button>
                              <Button
                                variant="destructive"
                                className=""
                                onClick={() => handleDelete(device.id)}
                              >
                                Delete
                              </Button>
                            </div>
                          </>
                        )}
                    </div>
                  </CardContent>
                </Card>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}
